export default "__VITE_ASSET__H_4ol1qg__"